import 'css-chunksrc/client/scenes/planzoneResourceGroupCreation/groupCreationForm/styles.scss';export default {
  "groupCreationForm": "_groupCreationForm_qfjyv_1",
  "group": "_group_qfjyv_1",
  "groupOverflow": "_groupOverflow_qfjyv_10",
  "title": "_title_qfjyv_14",
  "input": "_input_qfjyv_21",
  "textArea": "_textArea_qfjyv_33"
};